'use es6';

import http from 'hub-http/clients/apiClient';
import { getBusinessUnitDisplaysForUserRpc } from '../../__generated__/chirp/com/hubspot/business/units/rpc/BusinessUnitsDisplaysService';
import { getUserInfo } from 'reference-resolvers/api/UserInfoAPI';
import formatBusinessUnitDropdownOptions from 'reference-resolvers/formatters/formatBusinessUnitDropdownOptions';
import { rpcClient } from './rpcClient';
const BUSINESS_UNITS_CHIRP_MIGRATION_GATE = 'MultiAccountManagement:BusinessUnits:ChirpMigration';
const hasChirpMigrationGate = (gates = []) => gates.includes(BUSINESS_UNITS_CHIRP_MIGRATION_GATE);
export const createGetBusinessUnitDropdownOptions = ({
  httpClient,
  portalId,
  rpcHttpClient = rpcClient
}) => () => getUserInfo().then(userInfo => {
  const gates = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates) || [];
  if (hasChirpMigrationGate(gates)) {
    return rpcHttpClient.call(getBusinessUnitDisplaysForUserRpc, Object.assign({}, portalId && {
      portalId
    })).then(response => formatBusinessUnitDropdownOptions(response.businessUnitDisplays));
  }
  return httpClient.get('business-units/v1/business-unit-displays/user/dropdown', Object.assign({}, portalId && {
    query: {
      portalId
    }
  })).then(formatBusinessUnitDropdownOptions);
});
export const getBusinessUnitDropdownOptions = createGetBusinessUnitDropdownOptions({
  httpClient: http
});